import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * A pipe that sanitizes HTML content to prevent XSS attacks.
 */
@Pipe({
  name: 'safeHtml',
  standalone: true,
})
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Sanitizes the given HTML content to prevent XSS attacks.
   * @param value The HTML content to sanitize.
   * @returns The sanitized HTML content.
   */
  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
